import React, { useState } from "react";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Card, CardBody, FormFeedback } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from 'moment';

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { saveAs } from 'file-saver';
import Papa from "papaparse";

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UsersReport = props => {  
  const [modal_Delete_User, setmodal_Delete_User] = useState(false);
  function Delete_User() {
    setmodal_Delete_User(!modal_Delete_User);
    // removeBodyCss();
  }


  
  //meta title
  document.title = "Users Report";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      kyc_status: 'All',
      status: 'All',
      country: {label: 'All', value: 'All'},
      investment: 'All',
      crypto_wallet_deposit: 'All',
      crypto_wallet_used: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.kyc_status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.kyc_status);
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.status === values.status);
        }
        if(values.country.value !== 'All') {
          filteredData = filteredData.filter(item => item.country === values.country.value);
        }
        if(values.investment !== 'All') {
          filteredData = filteredData.filter(item => item.investment === values.investment);
        }
        if(values.crypto_wallet_deposit !== 'All') {
          filteredData = filteredData.filter(item => item.crypto_wallet_deposit === values.crypto_wallet_deposit);
        }
        if(values.crypto_wallet_used !== 'All') {
          filteredData = filteredData.filter(item => item.crypto_wallet_used === values.crypto_wallet_used);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="9" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      u_id: elementData.u_id,
      status: elementData.status,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      u_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
          status: values.status
        });
        const res = await postRequest('update-user-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [UsersData, setUsersData] = React.useState([]);
  const [CsvData, setCsvData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    setCsvData(tempData);

    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.u_id}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        <td>{element.email}</td>
        <td>{element.country}</td>
        <td>+{element.country_code} {element.phone.slice(0, 6)}****&nbsp;
            {parseInt(element.is_phone_verified) === 1 ? (
              <CheckCircleIcon style={{ color: 'green' }} />
            ) : (
              <CancelIcon style={{ color: 'red' }} />
            )}
        </td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.kyc_status === 'Pending' ? 'badge-soft-warning' : element.kyc_status === 'Approved' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.kyc_status}</span></td>
        <td>{
            (() => {

            if(element.kyc_status=='Pending'){
              return"-"
            }

            if(element.kyc_date){
              return moment(element.kyc_date).format('DD/MM/YYYY HH:mm')
            }else{
              const kycObject = JSON.parse(element.kyc_response);
              return moment(kycObject.createdUtc).format('DD/MM/YYYY HH:mm')
            }
            })()
        }</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td>{moment(element.created_at).format('DD/MM/YYYY HH:mm')}</td>
        <td>{element.investment}</td>
        <td>{
        (() => {
            if(element.investment_amount==0){
              return "-"
            }
            return element.investment_amount+" EUR";
            })()
        }</td>
        <td>{element.crypto_wallet_deposit}</td>
        <td>{
            (() => {
            if(element.crypto_wallet_deposit=="No"){
              return "-"
            }
            return element.crypto_wallet_used;
            })()
        }</td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }

  const handleDownloadCSV = () => {
    const transformedData = CsvData.map(user => ({
      "First Name": user.first_name,
      "Last Name": user.last_name,
      "Email": user.email,
      "Country": user.country,
      "Phone": `+${user.country_code} ${user.phone.slice(0, 6)}****`,
      "Kyc Status": user.kyc_status,
      "Kyc Date": (() => {
        if(user.kyc_status=='Pending'){
          return"-"
        }
  
        if(user.kyc_date){
          return moment(user.kyc_date).format('DD/MM/YYYY HH:mm')
        }else{
          const kycObject = JSON.parse(user.kyc_response);
          return moment(kycObject.createdUtc).format('DD/MM/YYYY HH:mm')
        }
      })(),
      "Register Date": moment(user.created_at).format('DD/MM/YYYY HH:mm'),
      "Investment": user.investment,
      "Investment Amount": (() => {
              if(user.investment_amount==0){
                return "-"
              }
              return user.investment_amount+" EUR";
      })(),
      "Deposit Crypto Wallet": user.crypto_wallet_deposit,
      "Used Crypto Wallet": (() => {
      if(user.crypto_wallet_deposit=="No"){
        return "-"
      }
      return user.crypto_wallet_used;
      })()
        
    }));
    
    const csv = Papa.unparse(transformedData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const currentDateTime = moment().format('DDMMYYYY_HHmmss');
    const filename = `users-report_${currentDateTime}.csv`;
    saveAs(blob, filename);
  };

  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;
    
      const walletDeposits = await handleLoadGetWalletCredit();
      const investments = await handleLoadGetPropertyInvestment();

      const updatedUsers = await Promise.all(
        originalText.map(async (element) => {
          let  is_investment = "No";
          let  total_value_token_price = 0;
          let  crypto_wallet_used = "No";

          investments.crypto_transaction.forEach(investment => {
            if(element.u_id == investment.u_id){
              crypto_wallet_used = "Yes";
            }
          });
          
          investments.filteredCryptoTransaction.forEach(investment => {
            if(element.u_id == investment.u_id){
              is_investment = "Yes";
              total_value_token_price = total_value_token_price + parseFloat(investment.value) * parseFloat(investment.token_price);
            }
          });
          if(total_value_token_price==0){
            is_investment = "No";
          }

          let wallet_credit = "No"

          walletDeposits.forEach(wallet => {
            if(element.u_id == wallet.u_id){
              wallet_credit = "Yes";
            }
          });
          
          return {
            ...element,
            investment: is_investment,
            investment_amount: total_value_token_price,
            crypto_wallet_deposit: wallet_credit,
            crypto_wallet_used: crypto_wallet_used
          };
        })
      );
      setUsersData(updatedUsers);
      setCsvData(updatedUsers)
      handleT1Body(updatedUsers);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="9" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const handleLoadGetPropertyInvestment = async () => {
    const res = await postRequest('get-all-user-property-investment');
    if (res && res.code === 200) {
      return res.data;
    }
    else {
      return [];
    }
  }

  const handleLoadGetWalletCredit = async () => {
    const res = await getRequest('get-fiat-credit-data');
    if (res && res.code === 200) {
      return res.data;
    }
    else {
      return [];
    }
  }

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
    handleLoadGetAllCountries();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Users Report")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">KYC Status : </label>
                          <select className="form-select" name="kyc_status" value={validation1.values.kyc_status} onChange={(e) => validation1.setValues({ ...validation1.values, kyc_status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Enable'}>Enable</option>
                            <option value={'Disable'}>Disable</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Country : </label>
                          <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Investment : </label>
                          <select className="form-select" name="investment" value={validation1.values.investment} onChange={(e) => validation1.setValues({ ...validation1.values, investment: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Deposit Crypto Wallet : </label>
                          <select className="form-select" name="crypto_wallet_deposit" value={validation1.values.crypto_wallet_deposit} onChange={(e) => validation1.setValues({ ...validation1.values, crypto_wallet_deposit: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Used Crypto Wallet : </label>
                          <select className="form-select" name="crypto_wallet_used" value={validation1.values.crypto_wallet_used} onChange={(e) => validation1.setValues({ ...validation1.values, crypto_wallet_used: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Yes'}>Yes</option>
                            <option value={'No'}>No</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={6} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" id="submit1" onClick={(e) => { e.preventDefault(); validation1.handleSubmit(); return false; }} color="primary" style={{ float: "left"}} >Search</Button>
                          <Button type="button" id="submit3" onClick={handleDownloadCSV} color="primary" className="bx bx-download" style={{ float: "right"}}></Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '2100px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email ID</th>
                            <th>Country Name</th>
                            <th>Mobile No.</th>
                            <th>KYC Status</th>
                            <th>KYC Date</th>
                            <th>Status</th>
                            <th>Register Date</th>
                            <th>Investment</th>
                            <th>Investment Amount</th>
                            <th>Deposit Crypto Wallet</th>
                            <th>Used Crypto Wallet</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(UsersReport);
